import * as v from 'valibot';
import { t } from 'i18next';
import { CampaignSplitOrder } from '~/api';
import { IdSchema, RequiredStringSchema } from '~/schemas';
import { createDict } from '~/helpers';

export const ProductClassBriefPrinterRequestSchema = v.object({
	productClassId: IdSchema,
	printerId: v.message(IdSchema, t('Vyberte agenturu.')),
});

export const CampaignBriefFormattingRequestSchema = v.pipe(
	v.object({
		additionalMaterialRequestId: v.nullable(IdSchema),
		campaignSplitId: v.nullable(IdSchema),
		campaignSplitOrderIds: v.array(v.number()),
		content: RequiredStringSchema,
		deadline: v.pipe(v.string(t('Zadejte datum.')), v.isoDate()),
		productClassBriefPrinters: v.array(ProductClassBriefPrinterRequestSchema),
	}),
	v.forward(
		v.partialCheck(
			[ [ 'campaignSplitId' ], [ 'additionalMaterialRequestId' ] ],
			({ campaignSplitId, additionalMaterialRequestId }) => {
				return (campaignSplitId != null) !== (additionalMaterialRequestId != null);
			},
			t('Zadejte kampaňový split nebo request na dodatečné materiály.'),
		),
		[ 'campaignSplitId' ],
	),
);

const ReservePercentageSchema = v.pipe(
	v.number(t('Zadejte číslo.')),
	v.integer(t('Zadejte celé číslo.')),
	v.minValue(0, t('Hodnota musí být nezáporné číslo.')),
	v.maxValue(100, t('Hodnota nesmí být větší než %count%.', { count: 100 })),
);

export const makeCampaignBriefPrintingRequestSchema = (orders: CampaignSplitOrder[]) => {
	const orderProductsCountById = createDict(orders, ({ id }) => id);

	return v.pipe(
		v.object({
			additionalMaterialRequestId: v.nullable(IdSchema),
			campaignSplitId: v.nullable(IdSchema),
			content: RequiredStringSchema,
			deadline: v.pipe(v.string(t('Zadejte datum.')), v.isoDate()),
			itemReservePercentage: ReservePercentageSchema,
			storeReservePercentage: ReservePercentageSchema,
			orders: v.array(v.pipe(
				v.object({
					orderId: IdSchema,
					quantity: v.pipe(
						v.number(t('Zadejte číslo.')),
						v.integer(t('Zadejte celé číslo.')),
					),
					manualQuantity: v.boolean(),
				}),
				v.forward(
					v.partialCheck(
						[ [ 'orderId' ], [ 'quantity' ] ],
						({ orderId, quantity }) => {
							const order = orderProductsCountById[orderId];
							const productsCount = order?.productsCount ?? 0;
							return quantity >= productsCount;
						},
						t('Množství musí být alespoň počet produktů objednávky.'),
					),
					[ 'quantity' ],
				),
			)),
			productClassBriefPrinters: v.array(ProductClassBriefPrinterRequestSchema),
		}),
		v.forward(
			v.partialCheck(
				[ [ 'campaignSplitId' ], [ 'additionalMaterialRequestId' ] ],
				({ campaignSplitId, additionalMaterialRequestId }) => {
					return (campaignSplitId != null) !== (additionalMaterialRequestId != null);
				},
				t('Zadejte kampaňový split nebo request na dodatečné materiály.'),
			),
			[ 'campaignSplitId' ],
		),
	);
};
